module.exports = __webpack_public_path__ + "static/media/git.b61ea2eb.svg";